import { ArcElement,Chart as ChartJS,Legend,Title,Tooltip } from "chart.js";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Pie } from "react-chartjs-2";

// Register ChartJS components
ChartJS.register(ArcElement, Title, Tooltip, Legend, ChartDataLabels);

const EmployeesByGenderChart = ({ genders }) => {
  const totalEmployees = genders.reduce((sum, g) => sum + g.count, 0);

  // Colors matching your original implementation
  const barColors = genders.map((g) =>
    g.name.toLowerCase() === "male" ? "#D3001A" : "#ffb500"
  );

  const data = {
    labels: genders.map((g) => {
      const name = g.name || '';
      return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
    }),
    datasets: [
      {
        label: "Employees",
        data: genders.map((g) => g.count),
        backgroundColor: barColors,
        borderWidth: 2,
        borderColor: "#ffffff",
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    onClick: (event, elements) => {
      if (elements.length > 0) {
        const index = elements[0].index;
        const gender = genders[index].name.toLowerCase();
        // Open in a new tab
        window.open(`/employees?gender=${gender}`, '_blank');
      }
    },
    onHover: (event, chartElement) => {
      event.native.target.style.cursor = chartElement.length ? 'pointer' : 'default';
    },
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
        align: 'center',
        labels: {
          usePointStyle: true,
          padding: 18,
          boxWidth: 12,
          boxHeight: 12,
          font: {
            size: 13,
            weight: '500',
            family: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
          },
          color: '#333',
          generateLabels: (chart) => {
            return genders.map((gender, index) => {
              const genderName = gender.name.charAt(0).toUpperCase() + gender.name.slice(1).toLowerCase();
              return {
                text: genderName,
                fillStyle: barColors[index],
                strokeStyle: barColors[index],
                lineWidth: 0,
                hidden: false,
                index: index
              };
            });
          }
        }
      },
      tooltip: {
        enabled: true,
        backgroundColor: 'rgba(255, 255, 255, 0.98)',
        titleColor: '#1f2937',
        bodyColor: '#4b5563',
        borderColor: 'rgba(0, 0, 0, 0.08)',
        borderWidth: 1,
        padding: 12,
        cornerRadius: 8,
        displayColors: true,
        boxWidth: 12,
        boxHeight: 12,
        titleFont: {
          size: 13,
          weight: '600',
          family: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
        },
        bodyFont: {
          size: 12,
          weight: '500',
          family: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
        },
        callbacks: {
          title: () => '',
          label: (context) => {
            const value = context.raw;
            const percentage = ((value / totalEmployees) * 100).toFixed(1);
            return [`${context.label}: ${value} employees`, `${percentage}% of total`];
          }
        },
      },
      datalabels: {
        display: true,
        color: '#FFFFFF',
        font: {
          size: 12,
          weight: '600',
          family: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
        },
        formatter: (value, context) => {
          const percentage = ((value / totalEmployees) * 100).toFixed(0);
          return `${percentage}%`;
        },
      },
    },
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "0",
        width: "100%",
        height: "100%",
      }}
    >
      <div style={{ height: "240px", width: "100%", paddingBottom: "10px", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Pie data={data} options={options} />
      </div>
    </div>
  );
};

export default EmployeesByGenderChart;
